import React from 'react';
import {
  Box, Button, Chip, MenuItem, Stack, TextField
} from '@mui/material';
import { DataGrid } from '../common/datagrid/ResponsiveDataGrid';
import dayjs from 'dayjs';
import {
  LEAVE_TYPE_COLORS,
  LEAVE_TYPE_LABELS,
} from '../../containers/attendancemng/AttendMngContainer';

const getYmOptions = () => {
  const options = [];
  const now = dayjs();
  for (let y = now.year(); y >= now.year() - 1; y--) {
    for (let m = 12; m >= 1; m--) {
      if (y === now.year() && m > now.month() + 1) continue;
      options.push(`${y}${String(m).padStart(2, '0')}`);
    }
  }
  return options;
};

const LeaveApprovalInboxTab = ({
  list,
  loading,
  searchYm,
  onSearchYmChange,
  onApprove,
  onReject,
  onRowClick,
}) => {
  const columns = [
    { field: 'reqNo', headerName: '신청번호', minWidth: 160, flex: 0.8 },
    { field: 'usrNm', headerName: '신청자', minWidth: 100, flex: 0.5 },
    { field: 'dptNm', headerName: '부서', minWidth: 120, flex: 0.7 },
    {
      field: 'leaveTyp',
      headerName: '구분',
      minWidth: 120,
      flex: 0.6,
      renderCell: ({ value }) => (
        <Chip
          label={LEAVE_TYPE_LABELS[value] || value}
          color={LEAVE_TYPE_COLORS[value] || 'default'}
          size="small"
          variant="outlined"
        />
      ),
    },
    {
      field: 'leaveDtSt',
      headerName: '기간',
      minWidth: 210,
      flex: 1,
      renderCell: ({ row }) => (
        `${dayjs(row.leaveDtSt).format('YYYY-MM-DD')} ~ ${dayjs(row.leaveDtEd).format('YYYY-MM-DD')}`
      ),
    },
    {
      field: 'leaveDays',
      headerName: '일수',
      minWidth: 80,
      flex: 0.4,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: (value) => value != null ? `${value}일` : '-',
    },
    { field: 'rmk', headerName: '사유', minWidth: 220, flex: 1.1 },
    {
      field: 'currentStepOrder',
      headerName: '결재 단계',
      minWidth: 110,
      flex: 0.6,
      align: 'center',
      headerAlign: 'center',
      renderCell: ({ row }) => `${row.currentStepOrder || 1} / ${row.stepCount || 1}`,
    },
    {
      field: 'submittedAt',
      headerName: '상신일',
      minWidth: 160,
      flex: 0.8,
      valueFormatter: (value) => value ? dayjs(value).format('YYYY-MM-DD HH:mm') : '-',
    },
    {
      field: 'actions',
      headerName: '',
      minWidth: 170,
      sortable: false,
      renderCell: ({ row }) => (
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="contained" color="success" onClick={() => onApprove(row)}>
            승인
          </Button>
          <Button size="small" variant="outlined" color="error" onClick={() => onReject(row)}>
            반려
          </Button>
        </Stack>
      ),
    },
  ];

  return (
    <Box>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <TextField
          select
          size="small"
          label="기준월"
          value={searchYm}
          onChange={(e) => onSearchYmChange(e.target.value)}
          sx={{ width: 140 }}
        >
          {getYmOptions().map((ym) => (
            <MenuItem key={ym} value={ym}>
              {ym.slice(0, 4)}년 {parseInt(ym.slice(4), 10)}월
            </MenuItem>
          ))}
        </TextField>
      </Stack>

      <DataGrid
        rows={list}
        columns={columns}
        getRowId={(row) => row.leaveReqId}
        loading={loading}
        autoHeight
        density="compact"
        disableRowSelectionOnClick
        onRowClick={(params) => onRowClick?.(params.row)}
        sx={{ bgcolor: 'background.paper', borderRadius: 1 }}
      />
    </Box>
  );
};

export default LeaveApprovalInboxTab;
